import { BroadcastChannel } from 'broadcast-channel';
import { appId } from '../constants/app';
import { SetAuthIdentityPayload } from '../types/auth-state';

type AuthMessage = {
  appId: string;
  payload: SetAuthIdentityPayload;
};

export const authChannel = new BroadcastChannel<AuthMessage>('auth');

export const postAuthMessage = async (payload: SetAuthIdentityPayload) => {
  authChannel.postMessage({ appId, payload });
};
